var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_vm._m(0),_c('successModal',{ref:"success_modal",on:{"confirm":_vm.closeSuccessModal}}),_c('errorModal',{ref:"error_modal",on:{"confirm":_vm.closeErrorModal}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row border-blue-bottom mb-3"},[_c('div',{staticClass:"col-md-12 mb-4 mt-4 ml-4 font-weight-bold text-gray"},[_vm._v(" Solution Approval ")])])
}]

export { render, staticRenderFns }